import React, { FC, useState } from 'react';
import { Button, Upload } from 'antd';
import { ButtonProps } from 'antd/es/button';
import { UploadFile, UploadProps } from 'antd/es/upload/interface';

export type UploadButtonProps = UploadProps & {
  buttonProps?: ButtonProps;
};

const UploadButton: FC<UploadButtonProps> = (props) => {
  const { buttonProps, beforeUpload, ...uploadProps } = props;

  const [file, setFile] = useState<UploadFile>();

  const handleBeforeUpload: UploadProps['beforeUpload'] = (_file, files) => {
    setFile(_file);
    if (beforeUpload) {
      return beforeUpload(_file, files);
    }
    return false;
  };

  return (
    <Upload fileList={[]} {...uploadProps} beforeUpload={handleBeforeUpload}>
      <Button type="dashed" {...buttonProps}>
        {file?.name ?? buttonProps?.children ?? 'Select file'}
      </Button>
    </Upload>
  );
};

export default UploadButton;
